
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/savings",
      function () {
        return require("private-next-pages/savings.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/savings"])
      });
    }
  